import React from "react";
import { useTranslation } from "react-i18next";

function About() {
  const { t } = useTranslation("about");
  const text = t("hero.description2");

  const urlRegex = /(https?:\/\/[^\s]+)/g;

  const parts = text.split(urlRegex);
  return (
    <section className="tc-about-style7">
      <div className="container">
        <div className="row gx-0 justify-content-between">
          <div className="col-lg-3 d-flex flex-column align-items-start">
            <div className="rotate-box w-100" data-speed="1" data-lag="0.4">
              <div className="d-flex flex-wrap gap-2 justify-content-start align-items-center">
                <img
                  src="/home7_landscape/assets/img/logoONE.png"
                  alt="decorative"
                  className="responsive-logo img-fluid"
                />
                <img
                  src="/home7_landscape/assets/img/logoART.png"
                  alt="decorative"
                  className="responsive-logo img-fluid"
                />
                <img
                  src="/home7_landscape/assets/img/logoCASA.png"
                  alt="decorative"
                  className="responsive-logo img-fluid"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="info wow fadeInUp slow" data-wow-delay="0.2s">
              <div className="text fsz-24 fw-500 mb-20">
                {t("hero.description1")}
              </div>
              <div className="text fsz-24 fw-500 mb-20">
                {parts.map((part, index) =>
                  urlRegex.test(part) ? (
                    <a
                      key={index}
                      href={part}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="italic"
                    >
                      {part}
                    </a>
                  ) : (
                    <span key={index}>{part}</span>
                  )
                )}
              </div>
              <div className="text fsz-24 fw-500 mb-20">
  {t("hero.description3")
    .split(/(oneart)/i)
    .map((part, index) => {
      const normalized = part.trim().toLowerCase();
      const isOneArt = normalized === "oneart" || normalized === "oneart.";

      if (isOneArt) {
        return (
          <span
            key={index}
            style={{
              fontFamily: "Montserrat, sans-serif",
              textTransform: "uppercase",
              whiteSpace: "nowrap",
            }}
          >
            {part.trim().toUpperCase()}
          </span>
        );
      }

      return <React.Fragment key={index}>{part}</React.Fragment>;
    })}
</div>


              <a
                href="/innerpages/portfolio"
                className="butn border rounded-pill border-green1 hover-bg-green1 text-capitalize color-green1 mt-70"
              >
                <span> {t("hero.viewApartmentsButton")} </span>
              </a>
              <a
                href="/innerpages/contact"
                className="butn border rounded-pill border-green1 hover-bg-green1 text-capitalize color-green1 mt-70 "
                style={{ marginLeft: "10px" }}
              >
                <span> {t("hero.viewApartmentsButton2")} </span>
              </a>
            </div>
          </div>

          <div className="col-lg-2">
            <div className="numbers mt-5 mt-lg-0">
              <div
                className="number-card wow zoomIn slow"
                data-wow-delay="0.4s"
              >
                <h2 className="numb">{t("stats.sustainability.number")}</h2>
                <small>{t("stats.sustainability.text")}</small>
              </div>
              <div
                className="number-card wow zoomIn slow"
                data-wow-delay="0.6s"
              >
                <h2 className="numb">{t("stats.distance.number")}</h2>
                <small>{t("stats.distance.text")}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
